export const products = [
    {
      id: 1,
      
      

      img: require('./images/nasha.png').default,
      link: "https://drive.google.com/file/d/1M4sva8CS58QUbXHgflzM8RqWkFXFh6kW/view?usp=sharing",
    },
    {
      id: 2,
      img: require('./images/muma.png').default,
      link: "https://drive.google.com/file/d/1FpNUMigvTK_u0STInlU_DdqWaCCqgYWt/view?usp=sharing",
    },
    {
      id: 3,
      img: require('./images/hungry.png').default,
      link: "https://drive.google.com/file/d/1iDi78JTdLrezq5N1VnovQYYI-xFPrSEs/view?usp=drive_link",
    },
    {
      id: 4,
      img: require('./images/snakee-game.png').default,
      link: "https://ritikaa-pandey.github.io/snake-game/",
    },
    {
      id: 5,
      img: require('./images/weather-app.png').default,
      link: "https://ritikaa-pandey.github.io/weather-app/",
    },
    {
      id: 6,
      img: require('./images/qna.png').default,
      link: "https://qna-model.netlify.app/",
    },
  ];
  